import Vue from "vue";

Vue.component("keywords", {
	props: ["language", "domain", "ids", "errorMessage", "label", "placeholder", "isReadOnly", "helperCode"],
	data() {
		return {
			items: [],
		};
	},
	computed: {
		keywordIds: {
			get() {
				const ids = this.ids;
				if (!ids || ids.length === 0) return [];
				return ids;
			},
			set(value) {
				if (value) {
					this.$emit("update:ids", value);
				} else {
					this.$emit("update:ids", []);
				}
			}
		}
	},
	methods: {
		getKeywordsForDropdown: function () {
			this.$services.keywords.getForDropdown({
					language: this.language,
					domain: this.domain
				})
				.then((data) => {
					this.items = data.items;
				});
		}
	},
	mounted() {
		this.getKeywordsForDropdown();
	},
	template: `
		<b-field label="" :type="errorMessage ? 'is-danger' : ''" :message="errorMessage">
			<wto-tag-input-ids :label="label" :placeholder="placeholder" :items="items" :ids.sync="keywordIds" :is-readonly="isReadOnly" :helper-code="helperCode"></wto-tag-input-ids>
		</b-field>
	`
});